import { render, staticRenderFns } from "./PopulationTile.vue?vue&type=template&id=53f81392"
import script from "./PopulationTile.vue?vue&type=script&lang=js"
export * from "./PopulationTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports